import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../utils/auth";
import useAdminType from "../../utils/hooks/adminTypeHook";

function ProtectedRoute() {
	const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (isAuthenticated()) {
			setIsUserAuthenticated(true);
		} else {
			navigate("/");
		}
	}, [navigate]);

	// Obtén el tipo de administrador desde las cookies o el almacenamiento local
	const adminType = useAdminType();

	// Ahora puedes redirigir a las rutas adecuadas según el tipo de administrador
	if (isUserAuthenticated) {
		if (adminType === "Amebo") {
			return <Outlet />; // Rutas para el tipo "Amebo"
		} else if (adminType === "Lealtad") {
			return <Outlet />; // Rutas para el tipo "Lealtad"
		} else if (adminType === "Proveedor") {
			return <Outlet />; // Rutas para el tipo "Proveedor"
		} else if (adminType === "Comercializador") {
			return <Outlet />; // Rutas para el tipo "Comercializador"
		} else if (adminType === "SupplierAdmin") {
			return <Outlet />; // Rutas para el tipo "SupplierAdmin"
		} else if (adminType === "ProveedorLealtad") {
			return <Outlet />; // Rutas para el tipo "ProveedorLealtad"
		} else if (adminType === "ComercializadorLealtad") {
			return <Outlet />; // Rutas para el tipo "ComercializadorLealtad"
		} else if (adminType === "SupplierAdminLealtad") {
			return <Outlet />; // Rutas para el tipo "SupplierAdminLealtad"
		}  else {
			navigate("/"); // Redirige al inicio si el tipo de administrador no está definido
			return null;
		}
	} else {
		return null;
	}
}

export default ProtectedRoute;